<div class="account-page" *ngIf="!loading">
  <div class="page-header">
    <h1><mat-icon class="header-icon">account_circle</mat-icon> My Account</h1>
    <p class="subtitle">Manage your profile and account settings</p>
  </div>

  <div *ngIf="profile; else noProfile" class="content-container">
    <!-- Profile Card -->
    <div class="profile-card">
      <div class="gradient-overlay"></div>
      <div class="profile-header">
        <div class="avatar-section">
          <div class="avatar-container">
            <img [src]="profile?.profileImages || 'assets/images/userbig.png'"
                 (error)="onImageError($event)"
                 alt="Profile"
                 class="profile-avatar" />
            <div class="avatar-overlay" *ngIf="uploadInProgress">
              <mat-icon class="upload-icon">cloud_upload</mat-icon>
              <span class="upload-text">Uploading...</span>
            </div>
            <div class="avatar-badge">
              <mat-icon>verified</mat-icon>
            </div>
          </div>
          <input #profileFile type="file" accept="image/*" (change)="onFileChange($event)" hidden />
          <button mat-raised-button
                  color="primary"
                  class="change-photo-btn"
                  (click)="profileFile.click()"
                  [disabled]="uploadInProgress">
            <mat-icon>{{ uploadInProgress ? 'hourglass_empty' : 'photo_camera' }}</mat-icon>
            {{ uploadInProgress ? 'Uploading...' : 'Change Photo' }}
          </button>
        </div>

        <div class="profile-info">
          <h2 class="user-name">{{ profile?.userName || profile?.name || 'User' }}</h2>
          <div class="user-role">
            <mat-icon class="role-icon">badge</mat-icon>
            <span>{{ profile?.role || 'No Role Assigned' }}</span>
          </div>
          <div class="user-meta">
            <div class="meta-item">
              <mat-icon>email</mat-icon>
              <span>{{ newEmail || 'No email' }}</span>
            </div>
            <div class="meta-item" *ngIf="profile?.empCode">
              <mat-icon>numbers</mat-icon>
              <span>ID: {{ profile?.empCode }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Information Card -->
    <div class="info-card">
      <div class="card-header">
        <h3 class="card-title">
          <mat-icon>info</mat-icon>
          Personal Information
        </h3>
        <div class="card-subtitle">Your professional details</div>
      </div>
      <div class="info-grid">
        <div class="info-item">
          <div class="icon-wrapper">
            <mat-icon class="info-icon">business</mat-icon>
          </div>
          <div class="info-content">
            <label>Department</label>
            <p>{{ profile?.department || 'Not specified' }}</p>
          </div>
        </div>

        <div class="info-item">
          <div class="icon-wrapper">
            <mat-icon class="info-icon">work</mat-icon>
          </div>
          <div class="info-content">
            <label>Job Role</label>
            <p>{{ profile?.role || 'Not specified' }}</p>
          </div>
        </div>

        <div class="info-item">
          <div class="icon-wrapper">
            <mat-icon class="info-icon">location_on</mat-icon>
          </div>
          <div class="info-content">
            <label>Location</label>
            <p>{{ profile?.location || 'Not specified' }}</p>
          </div>
        </div>

        <div class="info-item">
          <div class="icon-wrapper">
            <mat-icon class="info-icon">phone</mat-icon>
          </div>
          <div class="info-content">
            <label>Mobile</label>
            <p>{{ profile?.mobile || 'Not specified' }}</p>
          </div>
        </div>


        <div class="info-item" *ngIf="profile?.centre">
          <div class="icon-wrapper">
            <mat-icon class="info-icon">apartment</mat-icon>
          </div>
          <div class="info-content">
            <label>Centre</label>
            <p>{{ profile?.centre }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Email Settings Card - HIDDEN FOR NOW -->
    <!-- <div class="settings-card">
      <div class="card-header">
        <h3 class="card-title">
          <mat-icon>email</mat-icon>
          Email Settings
        </h3>
        <div class="card-subtitle">Update your email address</div>
      </div>
      <div class="email-section">
        <mat-form-field appearance="outline" class="email-field">
          <mat-label>Email Address</mat-label>
          <mat-icon matPrefix>alternate_email</mat-icon>
          <input matInput [(ngModel)]="newEmail" type="email" placeholder="your.email@example.com" />
          <mat-hint>This will be your new login email</mat-hint>
        </mat-form-field>
        <button mat-raised-button
                color="primary"
                (click)="changeEmail()"
                [disabled]="saving || !newEmail"
                class="update-btn">
          <mat-icon [class.rotating]="saving">{{ saving ? 'sync' : 'save' }}</mat-icon>
          {{ saving ? 'Updating...' : 'Update Email' }}
        </button>
      </div>
      <div class="email-note">
        <mat-icon>info_outline</mat-icon>
        <span>You will need to sign in again after changing your email address</span>
      </div>
    </div> -->
  </div>

  <ng-template #noProfile>
    <div class="no-profile-card">
      <div class="no-profile-content">
        <mat-icon class="no-profile-icon">person_off</mat-icon>
        <h3>No Profile Found</h3>
        <p>Unable to load your profile information. Please try refreshing the page.</p>
        <button mat-raised-button color="primary" (click)="ngOnInit()">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      </div>
    </div>
  </ng-template>
</div>
